import React, { useContext } from "react";
import { Menu, Container, Button, Dropdown, Image, Sidebar, Segment, Icon, Header } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { Link, NavLink } from "react-router-dom";
import { RootStoreContext } from "../../app/stores/rootStore";

const NavHRmanagement: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { user, logout } = rootStore.userStore;
  return (
    <Menu fixed="top" inverted style={{ marginLeft: '12%' }}   >
        <Menu.Item  as={NavLink} to="/hrmanagement/employees">
        Employees 
        </Menu.Item>
        <Menu.Item  as={NavLink} to="/hrmanagement/timesheets">
        Time Sheet 
        </Menu.Item>
        <Menu.Item  as={NavLink} to="/hrmanagement/bogs">
        BOG
        </Menu.Item>
        <Menu.Item  as={NavLink} to="/hrmanagement/jobposition">
        Position 
        </Menu.Item>
        <Menu.Item  as={NavLink} to="/hrmanagement/projecttimes">
        Project 
        </Menu.Item>
        <Dropdown item text="Certificate">
          <Dropdown.Menu>
            <Dropdown.Item
              as={NavLink}
              to="/hrmanagement/certificate"
              text="Certificate"
            />
            <Dropdown.Item
              as={NavLink}
              to="/hrmanagement/techniciancertificate/dashboard"
              text="Technician Certificate"
            />
          </Dropdown.Menu>
        </Dropdown>
        {user && (
          <Menu.Item position="right" style={{ marginRight: '17%' }}>
            <Image
              avatar
              spaced="right"
              src={user.image || "/assets/user.png"}
            />
            <Dropdown pointing="top left" text={user.displayName}>
              <Dropdown.Menu>
              <Dropdown.Item
                as={Link}
                to={`/employeeportal/profile`}
                text="My profile"
                icon="user"
              />
              <Dropdown.Item
                as={Link}
                to={`/employeeportal/certificate`}
                text="My certificate"
                icon="user"
              />
              <Dropdown.Item
                as={Link}
                to={"/employeeportal/assets"}
                text="My Assets"
                icon="user"
              />
                <Dropdown.Item onClick={logout} text="Logout" icon="power" />
              </Dropdown.Menu>
            </Dropdown>
          </Menu.Item>
        )}
    </Menu>
  );
};

export default observer(NavHRmanagement);
